import { Tag } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { config } from '../../constant';
import React, { Fragment, useState, useEffect, useCallback, useRef } from 'react';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const Donut = (props) => {
  const [option, setOption] = useState(getOption());
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);

  const abortController = useRef(new window.AbortController());
  let timeTicket = useRef(null);
  let requestCheck = useRef(true);


  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    translationCache,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);

  const getData = useCallback(async (activeLegends) => {
    requestCheck.current = false;
    let json = [];
    let { graphprops } = props;
    let errorInAPI = false;
    let noDataInDB = false;

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      let series = [];
      let total = 0;
      if (json && Array.isArray(json)) {
        let activeKeys = [];
        if (activeLegends) {
          activeKeys = Object.keys(activeLegends).filter((active) => {
            return activeLegends[active] === false;
          });
        }
        series = json.map((val) => {
          if (activeKeys && val.Description && activeKeys.includes(val.Description)) {
            if (val.Value !== null) total = parseInt(total) + 0;
          } else {
            if (val.Value !== null) total = parseInt(total) + parseInt(val.Value);
          }
          return { value: val.Value, name: val.Description };
        });
      }

      let title = {
        text: `Total: ${total}`,
        left: 'center',
        top: 'center',
        textStyle: {
          color: 'white'
        }
      };
      const newOption = cloneDeep(option);
      if (props.graphprops.donut && props.graphprops.donut.colors && props.graphprops.donut.colors.length !== 0) {
        newOption.color = [...props.graphprops.donut.colors];
      }
      series = await trendLabelTranslation(series, translationCache);
      let ShowTotal = props.graphprops && props.graphprops[props.graphprops.graph] && props.graphprops[props.graphprops.graph].ShowTotal ? props.graphprops[props.graphprops.graph].ShowTotal : '';
      if (ShowTotal === 'Yes') {
        newOption.title = title;
      }
      newOption.legend = {
        ...newOption.legend,
        selected: activeLegends
      };
      newOption.series[0].data = [...series];
      setOption(newOption);
      setRefreshDateTime(moment());
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  }, [props, option]);

  const onChartClick = async (params) => {
    var activeLegends = params.selected;
    getData(activeLegends);
  };

  let onEvents = {
    legendselectchanged: (cellData) => onChartClick(cellData)
  };

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          style={{ height: '90%', width: '100%' }}
          className="react_for_echarts"
          onEvents={onEvents}
        />
      )}
    </Fragment>
  );

  function getOption() {
    let theme = props.selectedThemeing;
    let option = {
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c} '
      },
      legend: {
        textStyle: {
          color: theme === 'lightTheme' ? 'black' : 'white',
          fontSize: 18,
          fontWeight: 'bold'
        }
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: 'black',
            name: props.graphprops.title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      series: [
        {
          name: props.graphprops.title,
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: true,
          label: {
            formatter: ' {b|{c}}  {per|{d}%}  ',
            color: theme === 'lightTheme' ? 'black' : 'white',
            backgroundColor: '#eee',
            borderColor: '#aaa',
            borderWidth: 1,
            borderRadius: 4,
            padding: [0, 4],
            rich: {
              b: {
                fontSize: 14,
                fontWeight: 'bold',
                color: theme === 'lightTheme' ? 'black' : 'white',
                lineHeight: 22,
                backgroundColor: '#c23531',
                padding: [3, 5],
                borderRadius: 2
              },
              per: {
                fontSize: 14,
                fontWeight: 'bold',
                color: theme === 'lightTheme' ? 'black' : 'white',
                backgroundColor: '#52c41a',
                padding: [3, 5],
                borderRadius: 2
              }
            }
          },
          data: []
        }
      ]
    };

    return option;
  }
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(Donut);